import {validatePhone} from "../utils/validatePhone";
import {callbackFormApi} from "../api/callbackForm";

export default (pageId) => ({
    pageId,
    state: false,
    step: 'form',
    windowWidth: window.innerWidth,
    name: '',
    phone: '',
    fieldsValidationState: {
        name: false,
        phone: false,
    },
    loading: false,
    close() {
        this.state = false;
        setTimeout(() => {
            this.step = 'form';
        }, 300)
    },
    setPopupHeight() {
        this.$refs.popup.style.height = null;
        this.$refs.popup.style.height = this.$refs.popup.scrollHeight + 'px';
    },
    onOpenPopupForm() {
        this.state = true;
    },
    async onSend() {
        let validationCorrect = true;
        if (this.name.length === 0) {
            validationCorrect = false;
            this.fieldsValidationState.name = true;
        }
        if (this.phone.length === 0 || !validatePhone(this.phone)) {
            validationCorrect = false;
            this.fieldsValidationState.phone = true;
        }
        if (!validationCorrect) {
            return false;
        }
        this.loading = true;

        try {
            await callbackFormApi.create({
                source: this.pageId,
                name: this.name,
                phone: this.phone,
                message: this.message,
            });
            this.step = 'success';
        } catch (error) {
            this.step = 'error';
        }
        this.resetForm();
        this.loading = false;
    },
    resetForm() {
        this.name = '';
        this.phone = '';
        this.fieldsValidationState.phone = false;
        this.fieldsValidationState.name = false;
    },
    init() {
        this.$watch('state', (value) => {
            if (value) {
                this.$store.body.fixed = true;
                setTimeout(() => {
                    this.setPopupHeight();
                }, 300)
            } else {
                this.$store.body.fixed = false;
                this.$refs.popup.style.height = null;
            }
        });
        this.$watch('name', () => {
            this.fieldsValidationState.name = false;
        });
        this.$watch('phone', () => {
            this.fieldsValidationState.phone = false;
        });
        addEventListener('resize', () => {
            if (window.innerWidth !== this.windowWidth) {
                this.windowWidth = window.innerWidth;
                this.setPopupHeight();
            }
        })
    }
});